import React, { useState, useEffect, useMemo } from "react";
import defaultImg from "../../assets/WidgetMaker/Brocken_Image.svg";
import Image from "antd/lib/image";
import { Modal } from "antd";
import CarouselWidgetMaker from "./Carousel";
import VideoPreview from "./VideoPreview";
import moment from "moment";
import PostCardDetails from "./PostCardDetails";
import {
  formatTextForDirection,
  getTextDirection,
  kFormatter,
} from "../../redux/constants";
import { useSelector } from "react-redux";
import EyeWhiteIcon from "../../assets/eye_icon_white.svg";
import HighCharts from "../utils/charts/HighCharts/index";
import uuid from "react-uuid";

const SurveyAttachment = ({
  el,
  i,
  PdfDownloadStatus,
  PptGeneratingStatus,
  data,
  isPreviewState,
  postText,
  deepDive,
  trendView,
  isCommandCenterScreen,
  graphData,
  custom_card_settings,
  isTrandsView = false,
  widget_id,
  isScheduleReportOpen,
  section_index,
  widget_index,
  isDeepDiveDashboardView = false,
}) => {
  const authParams = useSelector((state) => state.Authentication.authParams);
  const [visible, setVisible] = useState({ id: null, value: false });

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isVideoModalOpen, setIsVideoModalOpen] = useState(false);

  const [isModalLoader, setIsModalLoader] = useState(false);
  const [modalData, setIsModalData] = useState(null);
  const [isImage, setIsImage] = useState({});

  const [previewImgUrl, setPreviewImgUrl] = useState("");
  const [closeImagePreview, setCloseImagePreview] = useState(false);

  const [videoPreview, setVideoPreview] = useState();
  const [isValidUrlFlag, setIsValidUrlFlag] = useState(null);

  const [isNewData, setIsNewData] = useState(false);
  const [previousValue, setPreviousValue] = useState(null);

  useEffect(() => {
    if (el?.value !== previousValue) {
      animateUpdate(el?.value);
      setVideoPreview(videoPreview);
      setIsVideoModalOpen(isVideoModalOpen);
      setPreviewImgUrl(previewImgUrl);
      setCloseImagePreview(closeImagePreview);
    }
  }, [el?.value, previousValue]);

  const animateUpdate = (newValue) => {
    setIsNewData(true);
    setTimeout(() => {
      setPreviousValue(newValue);
      setIsNewData(false);
    }, 400);
  };

  const showModal = (data) => {
    const ThreeDGlobalPage =
      (authParams?.screen_id === "000-000-555" ||
        authParams?.screen_id === "000-000-551" ||
        authParams?.screen_id === "000-000-557") &&
      !isDeepDiveDashboardView
        ? true
        : false;
    const updateData = ThreeDGlobalPage
      ? {
          ...data,
          isModalOpen: !isModalOpen,
        }
      : data;
    setIsModalLoader(true);
    setIsModalOpen(true);
    setIsModalData(updateData);
  };

  const onImageError = (e, id) => {
    if (e?.type === "error") {
      setIsImage({
        ...isImage,
        [id]: true,
      });
    } else {
      setIsImage({
        ...isImage,
        [id]: false,
      });
    }
    return (e.target.src = defaultImg);
  };

  const isScontentLinkExpire = (mediaUrl, channelType) => {
    let isExpired = false;
    try {
      if (
        mediaUrl &&
        mediaUrl.indexOf("s3.amazonaws") == -1 &&
        mediaUrl.indexOf("images.locobuzz.com") == -1
      ) {
        const tokens = mediaUrl.split("&");
        const HexDecimalCode = tokens.filter((x) => x.includes("oe="));
        if (
          HexDecimalCode != null &&
          HexDecimalCode.length > 0 &&
          HexDecimalCode[0].startsWith("oe=")
        ) {
          let DecimalEpoch = 0;
          if (HexDecimalCode.length > 0) {
            const HexDecimalTime = HexDecimalCode[0].replace("oe=", "");
            DecimalEpoch = parseInt(HexDecimalTime, 16);
          }
          // DateTimeOffset.Now.ToUnixTimeSeconds()
          if (moment().unix() > DecimalEpoch && DecimalEpoch > 0) {
            isExpired = true;
          }
        }
      }
    } catch (exception) {
      return false;
    }

    return isExpired;
  };

  const handleVideoPreview = (imgUrl) => {
    setIsVideoModalOpen(true);
    setVideoPreview(imgUrl?.MediaUrl);

    let isValidUrlFlag = isScontentLinkExpire(imgUrl?.MediaUrl, 1);
    setIsValidUrlFlag(isValidUrlFlag);
  };

  const onClickImagePreview = (imgUrl) => {
    setPreviewImgUrl(imgUrl);
    setCloseImagePreview(true);
  };

  const handleCloseVideoModalClose = (value) => {
    setIsVideoModalOpen(value);
    setVideoPreview("");
  };

  const handleCloseImagePerview = () => {
    setPreviewImgUrl("");
    setCloseImagePreview(false);
    setIsVideoModalOpen(false);
    setVideoPreview("");
  };

  const commandCenterInfluencersPageId =
    authParams?.screen_id === "000-000-553" && !isDeepDiveDashboardView
      ? true
      : false;

  // if isCommandCenterScreen is true directly assign ppt view
  PptGeneratingStatus = isDeepDiveDashboardView
    ? false
    : authParams?.screen_id === "000-000-550" ||
      authParams?.screen_id === "000-000-551" ||
      authParams?.screen_id === "000-000-552" ||
      authParams?.screen_id === "000-000-553" ||
      authParams?.screen_id === "000-000-554" ||
      authParams?.screen_id === "000-000-555" ||
      authParams?.screen_id === "000-000-556" ||
      authParams?.screen_id === "000-000-557" ||
      authParams?.screen_id === "000-000-558" ||
      authParams?.screen_id === "000-000-559"
    ? false
    : isCommandCenterScreen
    ? isCommandCenterScreen
    : PptGeneratingStatus;
  const surveyCardChartRes = useMemo(() => {
    if (!graphData) {
      return null;
    }
    let chart_type = Object.keys(graphData)?.[0];
    let metaWidgetGraphData =
      graphData?.[chart_type === "horizontal-bar" ? "bar" : chart_type];

    let single =
      chart_type === "combination" ||
      chart_type === "grid" ||
      chart_type === "pivot-grid"
        ? metaWidgetGraphData?.[0]?.data
          ? metaWidgetGraphData?.[0]?.data
          : metaWidgetGraphData
        : metaWidgetGraphData?.[0]?.data
        ? metaWidgetGraphData?.[0]?.data
        : metaWidgetGraphData;
    let option = {
      // put here el?.chart_res
      // single: {
      //   data: graphData?.[Object.keys(graphData)[0]]?.data,
      // },
      single: Array.isArray(single) ? single : [single],

      // It will be hard coded
      style: {
        width: "100%",
        height: `${
          isScheduleReportOpen || PdfDownloadStatus ? "250px" : "350px"
        }`,
      },
      id: widget_id, // el?.chart_res[data]
      type: Object.keys(graphData)[0], // el?.chart_res[data]
      stacked: metaWidgetGraphData?.[0]
        ? metaWidgetGraphData[0]?.stacked
        : metaWidgetGraphData?.stacked, // el?.chart_res?.stacked
      chartGlobalDataLabel: false, // el?.chart_res?.stacked
      // chartGradientColor: true,
      chartGlobalDataStacked: false,
    };
    const chart_id = `surveycard_${option.type}_${i}`;
    return { id: chart_id, option: option };
  }, [graphData]);
  // console.log("surveyCardChartRes : ", surveyCardChartRes);
  let textDirection = getTextDirection(postText);
  let textDirectionClass = textDirection === "rtl" ? "text-right-arabic" : "";
  return (
    <div
      className={`cardList__body-description p-5 ${
        surveyCardChartRes?.option?.single
          ? "m-2 d-flex justify-content-between flex-column"
          : ""
      } ${
        ((authParams?.screen_id === "000-000-551" ||
          authParams?.screen_id === "000-000-555" ||
          authParams?.screen_id === "000-000-556") &&
          !deepDive &&
          !trendView &&
          !isDeepDiveDashboardView) ||
        postText?.length > 34 ||
        PdfDownloadStatus
          ? "justify-content-between d-flex align-items-start"
          : ""
      } ${
        commandCenterInfluencersPageId ? "d-flex flex-column-reverse" : ""
      } fontSize-12 pl-15 pr-15`}
      style={
        PdfDownloadStatus
          ? el?.EmailContentHtml && el?.EmailContentHtml !== "NA"
            ? { minHeight: "0rem" }
            : {}
          : {
              height:
                (authParams?.screen_id === "000-000-551" ||
                  authParams?.screen_id === "000-000-556") &&
                !deepDive &&
                !trendView &&
                !isDeepDiveDashboardView
                  ? "10rem"
                  : commandCenterInfluencersPageId &&
                    !isDeepDiveDashboardView &&
                    !el.isMenstionCountBlock
                  ? "auto"
                  : surveyCardChartRes?.option?.single
                  ? "45rem"
                  : el?.PlatformID === 1
                  ? "16.3rem"
                  : "20rem",
              overflow: "hidden",
            }
      }
    >
      <>
        {postText && (
          <div className={`text_regular break-word mb-1 ${textDirectionClass}`}>
            <b
              className={
                el?.PostURL && el?.PostURL?.trim() && el?.PostURL !== "NA"
                  ? ""
                  : "pointer-events1 cursor-default"
              }
              target="_blank"
              rel="noreferrer"
            >
              {formatTextForDirection(postText, textDirection)}
            </b>
          </div>
        )}
      </>

      <div style={{ width: `${"100%"}` }}>
        {}
        <HighCharts
          single={surveyCardChartRes?.option?.single}
          xaxis={"Name"}
          yaxis={"Count"}
          style={surveyCardChartRes?.option?.style}
          legend_position={"bottom"}
          id={surveyCardChartRes?.id}
          type={surveyCardChartRes?.option?.type}
          stacked={surveyCardChartRes?.option?.stacked}
          chartGlobalDataLabel={
            surveyCardChartRes?.option?.chartGlobalDataLabel
          }
          chartGradientColor={surveyCardChartRes?.option?.chartGradientColor}
          chartGlobalDataStacked={
            surveyCardChartRes?.option?.chartGlobalDataStacked
          }
          isSurveyCardChart={true}
          section_index={section_index}
          widget_index={widget_index}
          survey_card_post_text={postText}
        />
      </div>
    </div>
  );
};

export default SurveyAttachment;
